import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface KeyPlatformFeature {
  id: string;
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-key-platform-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './key-platform-features.component.html',
  styleUrl: './key-platform-features.component.scss',
})
export class KeyPlatformFeaturesComponent {
  features: KeyPlatformFeature[] = [
    { id: 'datasets', icon: '/about-us/Key/Database.svg', title: 'Datasets', description: 'A repository of data enabling holistic insights, policies & tech solutions.' },
    { id: 'models', icon: '/about-us/Key/Graph.svg', title: 'Models', description: 'Explore, test, & contribute AI models for real-world applications.' },
    { id: 'usecases', icon: '/about-us/Key/LightbulbFilament.svg', title: 'Use Cases', description: 'A library of use-cases to inspire the next generation of innovations.' },
    { id: 'sandbox', icon: '/about-us/Key/CodesandboxLogo.svg', title: 'Sandbox IDE', description: 'An environment to explore, & test APIs, data services, and platform capabilities.' },
    { id: 'challenges', icon: '/about-us/Key/Trophy.svg', title: 'Challenges', description: 'Participate in exciting challenges to showcase your technical skills.' },
    { id: 'discussions', icon: '/about-us/Key/Chats.svg', title: 'Discussions', description: 'Join conversations, share insights, and collaborate with a vibrant community.' },
  ];
}
